import { useObjectGet } from '../api/object'

export function DocumentFormatter({ id }: { id?: string }) {
	const { data: document } = useObjectGet('document', id)

	if (!id) return <em className="text-gray-400">nevyplněno</em>

	return <>{document?.name ?? document?.id ?? ''}</>
}
